
import React, { useEffect, useRef, useState } from 'react';
import Pagination from '../Header/Pagination';
import Modal from 'react-responsive-modal';
import DeleteDialogueBox from '../Common/deleteDialogue';
import PeriodSelectionForm from '../PeriodSelection/periodSelectionForm';
import { format } from 'date-fns';
import royContractServices from './royContractServices';

export function PayOutRatePeriods(payOutRatePeriods: any) {

    var [deleteJob, setdeleteJob] = useState<any>([]);
    const [saveAlert, setSaveAlert] = useState(false);
    const formValidation = useRef<HTMLDivElement>(null);
    const [deleteAlert, setDeleteAlert] = useState(false);
    const [fieldsInvalid, setfieldsInvalid] = useState(false);
    let [periodSelection, setperiodSelection] = useState(false);
    let [payOutRatePeriodsTotalRow, setpayOutRatePeriodsTotalRow] = useState(0);
    let [payOutRatePeriodsListing, setpayOutRatePeriodsListing] = useState<any>([]);
    let [editpayOutRatePeriods, seteditpayOutRatePeriods] = useState<any>([]);

    var payload = {
        pageNumber: 1,
        pageSize: 10,
        contractrefnum: payOutRatePeriods.data.contractRefNum
    }
    useEffect(() => {
        console.log(payOutRatePeriods);

        editpayOutRatePeriods.contractRefNum = payOutRatePeriods.data.contractRefNum;
        editpayOutRatePeriods.formatPeriod = payOutRatePeriods.data.formatDesc;
        editpayOutRatePeriods.regionPeriod = payOutRatePeriods.data.territoryCode;
        seteditpayOutRatePeriods(editpayOutRatePeriods);

        ratesBasisPeriodlist();
    }, []);

    const ratesBasisPeriodlist = () => {
        royContractServices.ratesBasisPeriod(payload).then((res: any) => {
            setpayOutRatePeriodsListing(res);
            setpayOutRatePeriodsTotalRow(res && res[0] && res[0].totalRows ? res[0].totalRows : 0)
        })
    }

    const closepayOutRatePeriods = () => {
        payOutRatePeriods.closepayOutRatePeriods()
    }

    const onChange = (period: any) => {
        console.log(period);

        console.log(format(new Date(period.periodFrom.month), 'MM dd'));
        if (period.periodFrom) {
            editpayOutRatePeriods.periodFrom = Number(period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd'));
        }

        if (period.periodTo) {
            editpayOutRatePeriods.periodTo = Number(period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd'));
        }

        seteditpayOutRatePeriods(editpayOutRatePeriods);
    }

    const handleNameOnChange = (n: any) => {
        payload.pageNumber = n.pageNumber;
        payload.pageSize = n.pageSize;
        ratesBasisPeriodlist();
    }

    const closePeriod = (e: any) => {
        console.log(e)
        periodSelection = false;
        setperiodSelection(false)
    }

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            royContractServices.ratesBasisPeriodDelete(deleteJob.ratesBasis_PeriodId).then(() => {
                setDeleteAlert(true);
                ratesBasisPeriodlist();
            })
            setTimeout(function () {
                setDeleteAlert(false);
            }, 3000);
        }

        setdeleteJob({});
    };

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        if (Field_type === "checkbox") {
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...editpayOutRatePeriods };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        editpayOutRatePeriods = updatedObject;
        seteditpayOutRatePeriods(editpayOutRatePeriods);

    };

    const handleSpecificField = (fieldName: any, value: any, object: any) => {
        console.log(fieldName)
        console.log(object)
        console.log(value)

        let updatedObject = { ...editpayOutRatePeriods }
        if (fieldName === 'groupDesc,territoryCode') {
            var found = object.filter((event: any) => (event.groupDesc === (value)));
            updatedObject.groupDesc = found[0].groupDesc
            updatedObject.territoryCode = found[0].groupingId
        }

        if (fieldName === 'UsePriceDesc,usePrice') {
            var found = object.filter((event: any) => (event.value === (value)));
            updatedObject.UsePriceDesc = found[0] && found[0].value ? found[0].value : ''
            updatedObject.usePrice = found[0] && found[0].key ? found[0].key : ''
        }


        if (fieldName === 'formatDesc,format') {
            var found = object.filter((event: any) => (event.formatDesc === (value)));
            updatedObject.formatDesc = found[0].formatDesc
            updatedObject.format = found[0].codingStr
        }

        editpayOutRatePeriods = updatedObject;
        seteditpayOutRatePeriods(editpayOutRatePeriods);
    }

    const handleFieldRequired = (object: any) => {
        const inputs: any = formValidation.current?.querySelectorAll('input');
        var valid = true;

        Object.values(inputs).map((values: any) => {
            const isRequired = document.getElementById(values.id)?.hasAttribute('required');

            if (isRequired) {
                if (!object[values.id]) {
                    var fieldName: any = document.getElementById(values.id);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }

        })
        return valid;
    }

    const savePayOutRate = () => {

        var valid = handleFieldRequired(editpayOutRatePeriods)

        if (valid) {
            royContractServices.ratesBasisPeriodSave(editpayOutRatePeriods).then(() => {
                setSaveAlert(true);
                ratesBasisPeriodlist();
            })

            setTimeout(function () {
                setSaveAlert(false);
            }, 3000);

        }
    }

    const clearSForm = () => {
        console.log(editpayOutRatePeriods)
        editpayOutRatePeriods.ratePeriod = ""
        editpayOutRatePeriods.periodTo = ""
        editpayOutRatePeriods.periodFrom = ""
        seteditpayOutRatePeriods({ ...editpayOutRatePeriods })
        console.log(editpayOutRatePeriods)
        const inputs: any = formValidation.current?.querySelectorAll('input');
        if (inputs) {
            Object.values(inputs).map((values: any) => {
                var fieldName: any = document.getElementById(values.id);
                if (fieldName) {
                    fieldName.style.border = "1px solid #47529d";
                }


            })
        }

    };


    return (
        <>
            <Modal open={payOutRatePeriods.payOutRatePeriods} onClose={() => closepayOutRatePeriods()} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-7 paddingCenterBox bgTransparent' }} >

                <div className='ws-12 box'>

                    <div className="row-fluid sortable">

                        <div className="box-header-main well"> <h2 ><i className="fa fa-info"></i> Calculation at different rates for specific periods</h2> </div>

                        <div className="box-content">
                            <div className="row-fluid">

                                <div className="form-format">
                                    <label className="control-label">Contract Ref Num</label>
                                    <div className="label-entries">
                                        <input className="input-xlarge ws-6" value={editpayOutRatePeriods.contractRefNum} type="text" readOnly />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label">Format/Source Codes</label>
                                    <div className="label-entries">
                                        <input className="input-xlarge ws-6" value={editpayOutRatePeriods.formatPeriod} name="formatPeriod" type="text" readOnly />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label">Region</label>
                                    <div className="label-entries">
                                        <input className="input-xlarge ws-6" value={editpayOutRatePeriods.regionPeriod} name="regionPeriod" type="text" readOnly />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label">Rate</label>
                                    <div className="label-entries">
                                        <input className="input-xlarge ws-6" value={editpayOutRatePeriods.ratePeriod ?? ""} onChange={(e: any) => handleFieldChange(e)} name="ratePeriod" type="number" />
                                    </div>
                                </div>

                                <div className="form-format">

                                    <div className="label-entries ws-2">

                                        <button className="icon-btn edit width90 height35 pull-right" onClick={() => setperiodSelection(true)}>
                                            <i className="fa fa-check"></i> Select
                                        </button>

                                    </div>
                                    <div className="label-entries ws-2">
                                        <input type="text" placeholder="From" id="from" name="periodFrom" value={editpayOutRatePeriods.periodFrom ?? ""} />
                                    </div>
                                    <div className="label-entries ws-2">
                                        <input type="text" placeholder="To" id="To" name="periodTo" value={editpayOutRatePeriods.periodTo ?? ""} />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="box-footer">
                            <button className="icon-btn info width90 height35" onClick={clearSForm}><i className="fa fa-refresh"></i> Reset</button>
                            <button className="icon-btn edit width90 height35" onClick={savePayOutRate}><i className="fa fa-save"></i> Save</button>
                        </div>
                    </div>

                    <div className="row-fluid">
                        <div className="ws-12">
                            <div className="box-header well"><h2>{payOutRatePeriodsTotalRow} record(s) found </h2> </div>

                            <div className="box-content">
                                {saveAlert && <div className="alert alert-success"> Rate   has been saved successfully</div>}
                                {deleteAlert && <div className="alert alert-success">Rate   has been deleted successfully</div>}

                                {(payOutRatePeriodsTotalRow == 0) && <div className="alert alert-info">No records to display</div>}

                                {(payOutRatePeriodsTotalRow > 0) && <div className="table-responsive">
                                    <table className="newTable">
                                        <thead>
                                            <tr>
                                                <th >ContractRefNum</th>
                                                <th >Format</th>
                                                <th >Period From</th>
                                                <th >Period To</th>
                                                <th >Rate</th>
                                                <th >Region</th>
                                                <th >Operation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {payOutRatePeriodsListing?.map((values: any) => {

                                                return (
                                                    <tr>
                                                        <td >{values.contractRefNum}</td>
                                                        <td >{values.formatPeriod}</td>
                                                        <td >{values.periodFrom}</td>
                                                        <td >{values.periodTo}</td>
                                                        <td >{values.ratePeriod}</td>
                                                        <td >{values.regionPeriod}</td>
                                                        <td >
                                                            <a onClick={() => seteditpayOutRatePeriods(values)} className="icon-btn edit"><i className="icon-pencil"></i></a>
                                                            <a onClick={() => setdeleteJob(values)} className="icon-btn delete"><i className="icon-trashcan"></i></a>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                                <div className="clearfix">

                                    {
                                        (() => {
                                            if (payOutRatePeriodsTotalRow && payOutRatePeriodsTotalRow > 10) {
                                                return <Pagination onChange={handleNameOnChange} totalRows={payOutRatePeriodsTotalRow} />
                                            }
                                        })()
                                    }

                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        (() => {
                            if (periodSelection === true) {
                                return <PeriodSelectionForm open={true} closePeriod={closePeriod} onChange={onChange} />;
                            }

                            if (deleteJob && deleteJob.ratesBasis_PeriodId) {
                                return <DeleteDialogueBox param={true} message={"delete the selected pay out rate"} onChange={Confirmation} />
                            }
                        })()
                    }
                </div>
            </Modal>
        </>
    )
}